var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "window",
      attrs: { id: "changelog", "aria-label": "Changelog" },
    },
    [
      _c("div", { staticClass: "header" }, [_c("SidebarToggle")], 1),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("router-link", { attrs: { id: "back-to-help", to: "/help" } }, [
            _vm._v("« Help"),
          ]),
          _vm.$store.state.versionData &&
          _vm.$store.state.versionData.current &&
          _vm.$store.state.versionData.current.version
            ? [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(
                    "\n\t\t\t\tRelease notes for " +
                      _vm._s(_vm.$store.state.versionData.current.version) +
                      "\n\t\t\t"
                  ),
                ]),
                _vm.$store.state.versionData.current.changelog
                  ? [
                      _c("h3", [_vm._v("Introduction")]),
                      _c("div", {
                        ref: "changelog",
                        staticClass: "changelog-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$store.state.versionData.current.changelog
                          ),
                        },
                      }),
                    ]
                  : [
                      _c("p", [
                        _vm._v(
                          "Unable to retrieve changelog for current release from GitHub."
                        ),
                      ]),
                      _c("p", [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://github.com/thelounge/thelounge/releases/tag/v" +
                                _vm.$store.state.serverConfiguration.version,
                              target: "_blank",
                              rel: "noopener",
                            },
                          },
                          [
                            _vm._v(
                              "View release notes for this version on GitHub"
                            ),
                          ]
                        ),
                      ]),
                    ],
              ]
            : _c("p", [_vm._v("Loading changelog…")]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }